import { QGL_Lib } from "./QGL_Lib";
import { Mat_SamletFastEjendom } from "./DFQGLTypes";

export class MatQGL_Lib extends QGL_Lib {


  async BestemtFastEjendom(bfeNr: string): Promise<{ MAT_SamletFastEjendom: { nodes: Mat_SamletFastEjendom[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ MAT_SamletFastEjendom: { nodes: any[] } }>(`
query {
  MAT_SamletFastEjendom(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      id_lokalId
      id_namespace
      BFEnummer
      status
      arbejderbolig
      erFaelleslod
      hovedejendomOpdeltIEjerlejligh
      landbrugsnotering
      udskiltVej
      forretningshaendelse
      forretningsomraade
      forretningsproces
      senesteSagLokalId
      paataenktHandling
      registreringFra
      registreringTil
      registreringsaktoer
      virkningFra
      virkningTil
      virkningsaktoer
      bygningPaaFremmedGrundFladeLiggerPaaSamletFastEjendom {
        nodes {
          BFEnummer
          status
          senesteSagLokalId
          ejerlejlighedErDelAfBygningPaaFremmedGrundFlade {
            nodes {
              BFEnummer
              status
              senesteSagLokalId
            }
          }
        }
      }
      bygningPaaFremmedGrundPunktLiggerPaaSamletFastEjendom {
        nodes {
          BFEnummer
          status
          senesteSagLokalId
          ejerlejlighedErDelAfBygningPaaFremmedGrundPunkt {
            nodes {
              BFEnummer
              status
              senesteSagLokalId
            }
          }
        }
      }
      ejerlejlighedErDelAfSamletFastEjendom {
        nodes {
          BFEnummer
          status
          senesteSagLokalId
        }
      }
      jordstykkeSamlesISamletFastEjendom {
        nodes {
          id_lokalId
          id_namespace
          status
          matrikelnummer
          delnummer
          registreretAreal
          vejareal
          vejarealberegningsstatus
          faelleslod
          brugsretsareal
          vandarealinkludering
          arealberegningsmetode
          arealbetegnelse
          arealtype
          forretningshaendelse
          forretningsomraade
          forretningsproces
          senesteSagLokalId
          skelforretningssagsLokalId
          supplerendeMaalingSagLokalId
          paataenktHandling
          registreringFra
          registreringTil
          registreringsaktoer
          virkningFra
          virkningTil
          virkningsaktoer
          stammerFraJordstykkeLokalId
          samletFastEjendomLokalId
          fredskov_areal
          fredskov_omfang
          jordrente_omfang
          klitfredning_areal
          klitfredning_omfang
          majoratsskov_nummer
          majoratsskov_omfang
          strandbeskyttelse_areal
          strandbeskyttelse_omfang
          centroideLiggerIndenForJordstykke {
            nodes {
              geometri {
                wkt
              }
              senesteSagLokalId
              status
            }
          }
          jordstykkeLiggerIEjerlav {
            ejerlavskode
            ejerlavsnavn
          }
          jordstykkeLiggerIMatrikelKommune {
            id_lokalId
          }
          jordstykkeLiggerIMatrikelRegion {
            id_lokalId
          }
          jordstykkeLiggerIMatrikelSogn {
            id_lokalId
          }
        }
      }
    }
  }
}
      `);
  }

  async simpleBFENummerQuery(bfeNr: string): Promise<any> {
    return {
      ...(await this.simpleMATQuery(bfeNr)),
      ...(await this.simpleEJLQuery(bfeNr)),
      ...(await this.simpleBPFGQuery(bfeNr)),
      ...(await this.simpleBPFGPQuery(bfeNr))
    }
  }

  async simpleMATQuery(bfeNr: string): Promise<any> {
    let isoNow = new Date().toISOString();
    return this.query<any>(`
query {
  MAT_SamletFastEjendom(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      BFEnummer
      status
    }
  }
}`, "MAT");
  }

  async simpleEJLQuery(bfeNr: string): Promise<any> {
    let isoNow = new Date().toISOString();
    return this.query<any>(`
query {
  MAT_Ejerlejlighed(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      BFEnummer
      status
      samletFastEjendomLokalId
    }
  }
}`, "MAT");
  }

  async simpleBPFGQuery(bfeNr: string): Promise<any> {
    let isoNow = new Date().toISOString();
    return this.query<any>(`
query {
  MAT_BygningPaaFremmedGrundFlade(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      BFEnummer
      status
      samletFastEjendomLokalId
    }
  }
}`, "MAT");
  }

  async simpleBPFGPQuery(bfeNr: string): Promise<any> {
    let isoNow = new Date().toISOString();
    return this.query<any>(`
query {
  MAT_BygningPaaFremmedGrundPunkt(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { BFEnummer: {eq: ${bfeNr} } status: {eq: "Gældende" }}
  ) {
    nodes {
      BFEnummer
      status
      samletFastEjendomLokalId
    }
  }
}`, "MAT");
  }
}